module.exports = __webpack_public_path__ + "static/media/down.b081b49f.svg";